import dayjs, { type Dayjs } from 'dayjs';

interface ChangeTarget {
  name: string;
  value: unknown;
  type?: string;
  checked?: boolean;
}

interface NumericBounds {
  min?: number;
  max?: number | string;
}

type ResolveRef = (ref: string) => number;

type FieldValue = string | number | boolean | null | undefined | number[] | { date: Dayjs }[];

const clampToBounds = (val: number | null, field: NumericBounds, resolveRef: ResolveRef): number | null => {
  if (Object.prototype.hasOwnProperty.call(field, 'max') && Object.prototype.hasOwnProperty.call(field, 'min') && val !== null) {
    const fieldMax = typeof field.max === 'string' ? resolveRef(field.max) : field.max;
    if (fieldMax !== undefined && val > fieldMax) {
      val = fieldMax;
    }
    if (field.min !== undefined && val < field.min) {
      val = field.min;
    }
  }
  return val;
};

export const coerceFieldValue = (
  { name, value, type, checked }: ChangeTarget,
  field: NumericBounds,
  resolveRef: ResolveRef,
): FieldValue => {
  let val: FieldValue = value as FieldValue;

  if (name.startsWith('cleaning_packages.') && type === 'number') {
    val = val === '' ? 0 : Number(value);
    val = clampToBounds(val, field, resolveRef);
  } else if (type === 'number') {
    val = val === '' ? null : Number(value);
    val = clampToBounds(val, field, resolveRef);
  }

  if (type === 'array') {
    val = (value as string).split(',').map((x: string) => Number(x));
    val = val.length && val[0] !== 0 ? val : null;
  }
  if (type === 'sarray') {
    const dates = (value as string).split(',').map((item: string) => ({ date: dayjs(item) }));
    val = dates.length ? dates : null;
  }
  if (type === 'checkbox') {
    val = checked;
  }
  if (type === 'switch') {
    val = checked;
  }

  return val;
};
